import { useTheme } from 'foundations-theming/utils';
export const useTypeCssObject = type => {
  const theme = useTheme();
  switch (type) {
    // Alert component styles
    case 'info':
      return {
        backgroundColor: theme.color['fill-info-subtle'],
        borderInlineColor: theme.color['border-info-default'],
        borderBlockColor: theme.color['border-info-default']
      };
    case 'warning':
      return {
        backgroundColor: theme.color['fill-caution-subtle'],
        borderInlineColor: theme.color['border-caution-default'],
        borderBlockColor: theme.color['border-caution-default']
      };
    case 'danger':
      return {
        backgroundColor: theme.color['fill-alert-subtle'],
        borderInlineColor: theme.color['border-alert-default'],
        borderBlockColor: theme.color['border-alert-default']
      };
    case 'success':
      return {
        backgroundColor: theme.color['fill-positive-subtle'],
        borderInlineColor: theme.color['border-positive-default'],
        borderBlockColor: theme.color['border-positive-default']
      };
    case 'tip':
      return {
        backgroundColor: theme.color['fill-surface-default'],
        borderInlineColor: theme.color['border-transitional-interactive-subtle'],
        borderBlockColor: theme.color['border-transitional-interactive-subtle']
      };

    // Banner component styles
    case 'banner':
      return {
        background: `linear-gradient(89deg, ${theme.color['fill-transitional-banner-gradient-color-1']}, ${theme.color['fill-transitional-banner-gradient-color-2']});`,
        color: theme.color['text-core-on-fill-default'],
        borderStyle: 'none'
      };

    // FireAlarm component styles
    case 'system-info':
      return {
        backgroundColor: theme.color['fill-info-subtle'],
        color: 'text-core-default',
        borderStyle: 'none'
      };
    case 'system-warning':
      return {
        backgroundColor: theme.color['fill-caution-subtle'],
        color: 'text-core-default',
        borderStyle: 'none'
      };
    case 'system-danger':
      return {
        backgroundColor: theme.color['fill-alert-subtle'],
        color: 'text-core-default',
        borderStyle: 'none'
      };
    default:
      {
        // Fallback to 'tip' style for invalid types to prevent runtime crashes
        // UIAlert's default styling (no type-specific classes) looks closer to 'tip' than 'info'
        // Using 'tip' maintains visual consistency with UIComponents behavior
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`Invalid alert type "${type}". Falling back to "tip" style. Valid types are: info, warning, danger, success, tip.`);
        }
        return {
          backgroundColor: theme.color['fill-surface-default'],
          borderInlineColor: theme.color['border-transitional-interactive-subtle'],
          borderBlockColor: theme.color['border-transitional-interactive-subtle']
        };
      }
  }
};